import Vue from 'vue';

export default {
    setInviteInfo(state, invite) {
        Vue.set(state, 'inviteInfo', invite);
    },

    setInvite(state, invite) {
        Vue.set(state, 'invite', invite);
    },

    setInputLimits(state, limits) {
        Vue.set(state, 'inputLimits', limits);
    },

    setGlobalConfiguration(state, cfg) {
        Vue.set(state, 'globalcfg', cfg);
    },

    setSignedInUsersCount(state, count) {
        state.signedInUsersCount = count;
    },

    setLoadingStatus(state, status) {
        state.isLoading = status;
    },
    
    setDownloadingStatus(state, status) {
        state.isDownloading = status;
    },

    setRedirectInfo(state, redirect) {
        state.redirectInfo = redirect;
    },

    setUIReload(state, reload) {
        state.reloadUI = reload;
    },

    resetStoreModuleData(state) {
        Vue.set(state, 'globalcfg', {});
        Vue.set(state, 'isLoading', false);
        Vue.set(state, 'isDownloading', false);
    },

    deleteRole(state, roleId) {
        let index = state.roles.findIndex(c => c.id === roleId);
        if (index >= 0) {
            state.roles.splice(index, 1);
        }
    },

    setRoles(state, roles) {
        Vue.set(state, 'roles', roles.map(role => ({id: role.id, name: role.name, permanent: role.permanent, permissions: role.permissions, value: role.id})));
    },

    createRole(state, item) {
        let index = state.roles.findIndex(c => c.id === item.id);
        let role = item;
        role.value = item.id;
        if (index >= 0) {
            state.roles[index] = role;
        } else {
            state.roles.push(role);
        }
    },
};
